import vue from 'vue'
import Toast from './Toast.vue'
import Tips from './Tips.vue'

// 生成一个扩展实例构造器
const ToastConstructor = vue.extend(Toast)
const TipsConstructor = vue.extend(Tips)

// 定义弹出组件的函数 接收三个参数 消息 toast类型 显示时间
function showToast(message, type = '', duration = 3000) {
  // 实例化一个 FollowToast.vue
  const _toast = new ToastConstructor({
    data() {
      return {
        showToast: true,
        type: type,
        message: message,
        duration: duration
      }
    }
  })

  // 把实例化的 FollowToast.vue 添加到 body 里
  let element = _toast.$mount().$el
  document.body.appendChild(element)

  // duration时间到了后隐藏
  setTimeout(() => {
    _toast.showToast = false
  }, duration)
}
// 定义弹出组件的函数 接收三个参数 消息 回调 是否显示取消按钮
function showTips(message, fun , btnEsc=true) {
  // 实例化一个 Tips.vue
  const _toast = new TipsConstructor({
    data() {
      return {
        show: true,
        message: message,
        btnEsc:btnEsc,
        fun: fun
      }
    }
  })

  // 把实例化的 FollowToast.vue 添加到 body 里
  let element = _toast.$mount().$el
  document.body.appendChild(element)
}

// 需要在main.js 里面使用 Vue.use(showToast);
showToast.install = (Vue) => {
  // 将组件注册到 vue 的 原型链里去,
  // 这样就可以在所有 vue 的实例里面使用 this.$toast()
  Vue.prototype.$toast = showToast;
  //UI要求统一提示，复写提示方法
  Vue.prototype.$message.success=(message,duration=3000)=>{showToast(message, 'success',duration)}
  Vue.prototype.$message.warning=(message,duration=3000)=>{showToast(message, 'warning',duration)}
  // Vue.prototype.$message.error=(message,duration=3000)=>{
  //   //ui新标准，如果是功能开发中则显示别一个模版
  //   if(message.indexOf('开发中')>-1)showToast(message, 'kfz',duration)
  //   else showToast(message, 'error',duration)
  // }
  Vue.prototype.$message.cancel=(message,duration=3000)=>{showToast(message, 'cancel',duration)}
  Vue.prototype.$message.kfz=(message,duration=3000)=>{showToast(message, 'kfz',duration)}
  Vue.prototype.$message.tips=(message,fun)=>{showTips(message, fun)}
  Vue.prototype.$message.tipslist=(message,fun)=>{showTips(message, fun , false)}
}

// 导出
export default showToast
